import { PRODUCT_CATEGORY_SLUGS } from '../constants/productCategories';

function normalizeCategorySlug(raw: unknown): string | undefined {
  if (raw == null) return undefined;
  const s = String(raw).trim().toLowerCase();
  if (!s) return undefined;
  return PRODUCT_CATEGORY_SLUGS.has(s) ? s : undefined;
}

function extractFromMessage(message: unknown, currentCategory?: string | null): string | undefined {
  const msg = String(message || '');
  if (!msg) return undefined;
  const current = normalizeCategorySlug(currentCategory) || String(currentCategory || '').trim().toLowerCase();
  // Use exec (not matchAll) so CRA's older TS target does not need downlevelIteration.
  const pattern = /['"]([\w-]+)['"]/g;
  const candidates: string[] = [];
  let match: RegExpExecArray | null;
  while ((match = pattern.exec(msg)) !== null) {
    const slug = normalizeCategorySlug(match[1]);
    if (slug && slug !== current) candidates.push(slug);
  }
  return candidates.length > 0 ? candidates[candidates.length - 1] : undefined;
}

export function resolveCategorySuggestedFix(args: {
  suggestedFix?: unknown;
  suggestedCategory?: unknown;
  message?: unknown;
  currentCategory?: string | null;
}): string | undefined {
  const current =
    normalizeCategorySlug(args.currentCategory) ||
    String(args.currentCategory || '').trim().toLowerCase();
  const candidates = [
    normalizeCategorySlug(args.suggestedFix),
    normalizeCategorySlug(args.suggestedCategory),
    extractFromMessage(args.message, args.currentCategory),
  ].filter((s): s is string => !!s && s !== current);
  return candidates[0];
}

export function enrichCategoryVerificationIssue<T extends {
  field: string;
  autoFixable?: boolean;
  suggestedFix?: unknown;
  message?: string;
}>(
  issue: T,
  suggestedCategory: unknown,
  currentCategory?: string | null
): T {
  if (issue.field !== 'category') return issue;
  const cat = resolveCategorySuggestedFix({
    suggestedFix: issue.suggestedFix,
    suggestedCategory,
    message: issue.message,
    currentCategory,
  });
  if (!cat) {
    return { ...issue, autoFixable: false, suggestedFix: undefined };
  }
  return { ...issue, autoFixable: true, suggestedFix: cat };
}
